import axiosInstance from 'utils/AxiosInstance'
import * as types from './types'
import AxiosInstance from 'utils/AxiosInstance'

export const userLogin =
  (callback = null) =>
  async (dispatch) => {
    const user = await axiosInstance.get('/users/self')
    if (user.archived === 1) {
      alert('Please contact the administrator. This user is archived')
      return
    }
    localStorage.setItem('user', JSON.stringify(user))
    dispatch({
      type: types.SET_USER,
      payload: user,
    })

    if (callback) {
      callback()
    }
  }

export const updateCurrentUser = (user) => async (dispatch) => {
  localStorage.setItem('user', JSON.stringify(user))
  localStorage.setItem('token', user.token)

  dispatch({ type: types.SET_INFO, payload: user })

  // dispatch(fetchCurrentUser())
}

export const fetchCurrentUser = () => async (dispatch) => {
  const user = await axiosInstance.get('/users/self')

  if (!user.last_activity) {
    const now = new Date()
    const pad = (n) => n.toString().padStart(2, '0')
    const formatted = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(
      now.getDate()
    )} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`
    user.last_activity = formatted
  }

  localStorage.setItem('user', JSON.stringify(user))
  dispatch({ type: types.SET_INFO, payload: user })
}

export const setUserFirstName = (event) => ({
  type: types.SET_FIRST_NAME,
  payload: event.target.value,
})

export const userLogout = () => async (dispatch) => {
  dispatch({
    type: types.HANDLE_LOGOUT,
    payload: null,
  })
}
export const setUserLastName = (event) => ({
  type: types.SET_LAST_NAME,
  last_name: event.target.value,
})
export const setUserEmail = (event) => ({
  type: types.SET_EMAIL,
  email: event.target.value,
})

export const sidebarStatus = (status) => ({
  type: types.SIDEBAR_STATUS,
  payload: status,
})

export const toggleScaledDashboard = (payload) => ({
  type: types.TOGGLE_SCALED_DASHBOARD,
  payload: payload,
})

export const updateUserLastActivity = () => {
  return (dispatch, getState) => {
    AxiosInstance.patch(`/users/user-last-acitivity`).then(() => {})
  }
}

// export const resetPassword = (event, password, confirmPassword) => {
//   return (dispatch, getState) => {
//     event.preventDefault()

//     // Hardcoded default English language
//     // Change to user input if needed
//     const languageId = 1

//     const windowUrl = new URL(window.location.href)
//     const hash = windowUrl.searchParams.get('hash')

//     if (!password) {
//       alert('Please type your new password')
//       return
//     }
//     if (password.length < 6) {
//       alert('Password should contain at least 6 characters')
//       return
//     }
//     if (password !== confirmPassword) {
//       alert('Your password does not match')
//       return
//     }

//     let data = {}
//     data.hash = hash
//     data.password = password
//     data.languageId = languageId

//     axiosInstance
//       .post(`/users/reset-password?token=${hash}`, data)
//       .then((response) => {
//         if (!response.success) {
//           alert('Something went wrong')
//           return
//         }
//         // if (!response.data) {
//         //   alert('Something went wrong')
//         //   return
//         // }

//         if (!response.data.success) {
//           alert(response.data.message)
//           return
//         }
//         dispatch(toggleSentResetEmail())
//         // dispatch({ type: types.PASSWORD_CHANGED, changed: true })
//       })
//       .catch((error) => {
//         console.error('Error resetting password:', error)
//         // Handle error appropriately
//       })
//   }
// }
